export default __webpack_public_path__ + "static/media/uploader-tandem-4.59133ae9.png";